// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"styles_modal-body_3sEvTL5TNXm1th9CiOpeZV","modalBody":"styles_modal-body_3sEvTL5TNXm1th9CiOpeZV"};